<template>
  <div>
    <b-modal v-model="forgotModal " hide-footer hide-header size="sm">
      <template v-slot:default="{ hide }">
        <div class="row mb-5">
          <div class="col-10 px-0">
            <p class="text-center ml-5 mt-3 mb-0"><b>{{$t("message.create_naw_password")}}</b></p>  
          </div>
          <div class="col-1 px-0">
            <button class="btn btn-md " @click="hide()"><h3>×</h3></button>          
          </div>
        </div>

        <validation-observer class="form bg-white" ref="obs" >
          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.mail_adress")}}</label>
              <validation-provider name="confirm" rules="required">
                <div slot-scope="confirmScope"> 
                  <input  class="dirty b-w-0 p-2 bg-gray width100" v-model="username" placeholder="ex）test@test.com">
                  <p v-if="confirmScope.failed" class="error">{{ confirmScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3 mb-4">
            <div class="col-12 mx-auto">
              <b-button  class="login py-2 px-4 width100" @click="forgotPassword" > {{$t("message.confirm")}} </b-button>
            </div>
          </div>
        </validation-observer>
      </template>
    </b-modal>

    <b-modal v-model="forgotSubmitModal " hide-footer hide-header size="sm">
      <template v-slot:default="{ hide }">
        <div class="row mb-5">
          <div class="col-10 px-0">
            <p class="text-center ml-5 mt-3 mb-0"><b>{{$t("message.create_naw_password")}}</b></p>  
          </div>
          <div class="col-1 px-0">
            <button class="btn btn-md " @click="hide()"><h3>×</h3></button>          
          </div>
        </div>

        <validation-observer class="form bg-white" ref="forgot" >
          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.mail_adress")}}</label>
              <validation-provider name="mail_adress" rules="required">
                <div slot-scope="userScope"> 
                  <input  class="dirty b-w-0 p-2 bg-gray width100" v-model="username" placeholder="ex）test@test.com">
                  <p v-if="userScope.failed" class="error">{{ userScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.account_confirm")}}</label>
              <validation-provider name="confirm" rules="required">
                <div slot-scope="confirmScope"> 
                  <input  class="dirty b-w-0 p-2 bg-gray width100" v-model="confirmCode">
                  <p v-if="confirmScope.failed" class="error">{{ confirmScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.new_password")}}</label>
              <validation-provider name="newPass" rules="required|password">
                <div slot-scope="newScope"> 
                  <input :type="inputNewType" class="dirty b-w-0 p-2 bg-gray width100" v-model="newPass">
                  <span class="field-icon" @click="switchNewPassword">
                    <font-awesome-icon fas :icon="iconNew" />
                  </span>
                  <p v-if="newScope.failed" class="error">{{ newScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 mx-auto">
              <label ><span class="text-danger">*</span>{{$t("message.check_new_password")}}</label>
              <validation-provider name="confirmPass" rules="required|confirmed:newPass">
                <div slot-scope="confirmPass"> 
                  <input :type="inputNewConfirmType" class="dirty b-w-0 p-2 bg-gray width100" v-model="checkNewPass">
                  <span class="field-icon" @click="switchNewPasswordConfirm">
                    <font-awesome-icon fas :icon="iconNew" />
                  </span>
                  <p v-if="confirmPass.failed" class="error">{{ confirmPass.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mt-3 mb-4">
            <div class="col-12 mx-auto">
              <b-button  class="login py-2 px-4 width100" @click="forgotSubmit" > {{$t("message.edit")}} </b-button>
            </div>
          </div>
        </validation-observer>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {Auth} from 'aws-amplify';
export default {
  components: {
  },
  data() {
    return {
      forgotModal: false,
      forgotSubmitModal: false,
      username: "",
      newPass: "",
      checkNewPass: "",
      confirmCode: "",
      inputNewType: 'password',
      inputNewConfirmType: 'password',
      iconNew: "eye",
      iconNewConfirm: "eye",
      isNewChecked: false,
      isNewConfirmChecked: false,
    }
  },
  methods: {
    forgotPassword () {
      this.$refs.obs.validate().then(value =>{
        if(value){
          Auth.forgotPassword(this.username)
            .then(() => {
              this.$swal.fire({
                icon: 'success',
                title: this.$i18n.t('message.send_confirmcode') 
              }).then(()=>{
                this.showForgotSubmitModal()
              })
            })
            .catch(() => {
              this.$swal.fire({
                icon: 'error',
                title: this.$i18n.t('message.error_email') 
              })
            })
          }
        })
      .catch(err => {
        console.log(err)
      })
    },
    forgotSubmit(){
      this.$refs.forgot.validate().then(value =>{
        if(value){
          Auth.forgotPasswordSubmit(this.username, this.confirmCode, this.newPass)
            .then(() => {
              this.$swal.fire({
                icon: 'success',
                title: this.$i18n.t('message.success_new_password_setting')+ this.$i18n.t('message.retry_login')
              }).then(()=>{
                this.hideForgotSubmitModal()
              })
            })
            .catch(err => {
              console.log('dsfsfdsdf',err)
            })
          }
        })
      .catch(err => {
        console.log(err)
      })
    },
    showForgotSubmitModal(){
      this.forgotModal = false
      this.forgotSubmitModal = true
    },
    hideForgotSubmitModal(){
      this.forgotSubmitModal = false
    },
    showLogin(){
      this.closeModal()
      this.$emit('showLogin')
    },
    showModal(){
      this.forgotModal = true
    },
    switchNewPassword(){
      if (this.isNewChecked) {
        this.isNewChecked = false
        this.inputNewType = "text"
        this.iconNew = "eye-slash"
      } else {
        this.isNewChecked = true
        this.inputNewType = "password"
        this.iconNew = "eye"
      }
    },
    switchNewPasswordConfirm(){
      if (this.isNewConfirmChecked) {
        this.isNewConfirmChecked = false
        this.inputNewConfirmType = "text"
        this.iconNewConfirm = "eye-slash"
      } else {
        this.isNewConfirmChecked = true
        this.inputNewConfirmType = "password"
        this.iconNewConfirm = "eye"
      }
    },
  },
}
</script>
<style scoped lang="scss"> 
.btn{
  padding: .235rem .75rem;
}
@media (max-width: 768px) {
  .navbar-nav {
    -webkit-box-orient: horizontal !important;
    display: -webkit-box;
  }
}

.modal-header{
  border-bottom: 0px solid #dee2e6;
  text-size: 16px;
  text-align: center!important;
}

.sign_up{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 14px;

  &:hover {
    box-shadow: none !important;
  }
}

</style>
